import React, { SVGProps } from "react";

const SvgRoof5 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof027 dims 1">
      <path
        fill="#b4c5d3"
        d="M130.615 214.855v38.473l178.998-103.459v-38.473L130.615 214.855z"
      />
      <path
        fill="#fff"
        d="M130.615 214.855v38.473L28.508 194.513v-49.147l45.895-18.605 56.212 88.094z"
      />
      <g fill="#6d9faf">
        <path d="M78.335 149.244v10.3l-8.563-4.933v-10.3l8.563 4.933zM88.825 155.3v10.3l-8.563-4.932v-10.301l8.563 4.933zM78.335 161.58v10.3l-8.563-4.933v-10.3l8.563 4.933zM88.825 167.636v10.3l-8.563-4.932v-10.301l8.563 4.933z" />
      </g>
      <path
        fill="#237bae"
        d="m319.92 105.305-189.305 109.55-56.731-87.811 189.72-109.468 56.316 87.729z"
      />
      <path
        fill="#48d7ff"
        d="M263.604 17.576 73.884 127.044l-55.802 22.574L207.647 40.059l55.957-22.483z"
      />
      <path
        fill="#b4c5d3"
        d="M177.717 128.234v28.867l66.64-38.589V89.645l-66.64 38.589z"
      />
      <path
        fill="#fff"
        d="M177.717 128.234v28.867l-43.576-64.964 43.576 36.097z"
      />
      <path
        fill="#309ed6"
        d="m134.141 92.137 47.873 42.595 69.199-40.066-47.873-42.595-69.199 40.066z"
      />
      <path
        fill="#255d63"
        d="M199.088 128.494v12.857l10.949-6.34v-12.857l-10.949 6.34zM212.329 120.85v12.857l10.948-6.341v-12.857l-10.948 6.341z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M244.357 98.635v19.877l-66.64 38.589-43.576-64.964"
        />
        <path
          stroke="#3f3f3f"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="m232.266 194.574-101.651 58.754-102.107-58.815v-49.147M299.028 155.986l-56.731 32.792M309.613 111.396v38.473l-2.176 1.258"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M130.615 214.855v38.473"
        />
        <path
          stroke="#002839"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m276.94 130.179 42.98-24.874-56.316-87.729-55.957 22.483L18.082 149.618l55.802-22.574 56.731 87.811 68.011-39.36M208.868 169.573l56.556-32.734"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="M74.27 126.337 263.604 17.576"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M177.717 156.601v-25.692"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          d="m203.835 52.142 47.378 42.524-69.199 40.066-47.873-42.595"
        />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m108.553 266.398 16.75-9.682M7.105 207.944l16.71-9.718M11.357 205.682l101.015 58.203" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m168.064 275.103-32.235-18.622M347.021 171.899l-32.194-18.658M342.541 169.768 164.402 272.5" />
      </g>
      <g fill="none" stroke="#fff" strokeLinejoin="round" opacity={0.5}>
        <path d="M177.717 127.295v-2" />
        <path strokeDasharray="3.36681 3.36681" d="M177.717 121.928v-5.05" />
        <path d="M177.717 115.194v-2" />
      </g>
      <text
        transform="translate(257.345 231.622)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(53.105 247.809)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M342.888 166.054v6.926M164.006 269.194v6.926M112.696 260.646v6.925M11.161 202.094v6.926"
      />
      <text
        transform="translate(14.654 123.65)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P1"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M68.421 123.87 4.478 86.941M10.024 86.39l-6.582 3.8M23.571 143.804l-1.718 7.402M22.794 147.486c-10.03-19.461-15.97-40.468-16.025-59.233"
      />
      <path
        d="M245.35 75.603a49.685 49.685 0 0 1-.395 6.455 39.977 39.977 0 0 1-.991 5.119"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <text
        transform="translate(251.54 88.498)"
        fontSize={16}
        fill="#fff"
        fontFamily="'Effra Regular', Effra"
      >
        {"P2"}
      </text>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m249.162 77.814-36.13-20.87M248.424 73.644l-6.582 3.8M247.099 86.522l-6.76 3.473"
      />
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m253.959 201.114-69.416-40.088M320.761 162.664l-69.376-40.125M316.562 160.695l-66.196 38.102"
      />
      <text
        transform="translate(284.095 190.547)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"C"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M316.909 156.981v6.925M250.182 195.368v6.926"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m146.938 134.95 27.397-15.828M107.767 107.382l43.435 24.96"
      />
      <text
        transform="translate(117.676 132.384)"
        fontSize={16}
        fill="#fff"
        fontFamily="'Effra Regular', Effra"
      >
        {"D"}
      </text>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M151.081 129.198v6.926M107.57 103.794v6.926"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinejoin="round"
        strokeDasharray={4}
        opacity={0.5}
        d="m141.467 96.348 38.742 22.251"
      />
    </g>
  </svg>
);

export default SvgRoof5;
